import { ApprovalRequestsTab } from '../common'
import { Request, RequestHistory } from '../reshipments'
import { ContactInformation } from '../common/detail'
import { selectCurrentFilter } from '../../../selectors/filters'
import {
  APPROVAL_REQUEST_CONFIG,
  ARTYPE_RESHIPMENTS,
  AR_ID,
  AR_AICODE,
  AR_STATUS,
} from '../../../constants/ApprovalRequestConstants'

const mapStateToProps = state => ({
  groupByAICode: selectCurrentFilter(state).groupByAICode || false,
})

export const ReshipmentsTab = connect(mapStateToProps)(({ groupByAICode }) => {
  const requestDetailPanels = [
    {
      title: 'Contact Information',
      PanelBody: ContactInformation,
      panelId: 'contactInformationPanel',
    },
    { title: 'Request History', PanelBody: RequestHistory, panelId: 'requestHistoryPanel' },
  ]
  const headerColumns = [
    {
      headerText: { title: 'ID' },
      headerAttributes: { id: 'approvalRequestIdCol' },
      key: [`${APPROVAL_REQUEST_CONFIG[ARTYPE_RESHIPMENTS].idField}`],
      sortDir: ['asc'],
    },
    {
      headerText: { title: 'Earliest Exam Date' },
      headerAttributes: { id: 'adminDateCol' },
      key: ['earliestAdminDateTime', 'aiCode'],
      sortDir: ['asc', 'asc'],
      defaultSort: true,
    },
    {
      headerText: { title: 'AI Code' },
      headerAttributes: { id: 'aiCodeCol' },
      key: ['aiCode'],
      sortDir: ['asc'],
    },
    {
      headerText: { title: 'Status' },
      headerAttributes: { id: 'statusCol' },
      key: ['statusSortOrder', 'aiCode'],
      sortDir: ['asc', 'asc'],
    },
  ]

  const approvalRequestColumns = [
    { header: AR_ID },
    { header: 'adminDateCol', field: 'earliestAdminDateTime' },
    { header: AR_AICODE },
    { header: AR_STATUS },
  ]

  return (
    <ApprovalRequestsTab
      title="Reshipments"
      arType={ARTYPE_RESHIPMENTS}
      tableSummary={`Reshipments approval requests are listed in ascending order ${
        groupByAICode ? 'grouped by AI code' : 'by earliest exam date and AI code'
      }.`}
      headerColumns={headerColumns}
      approvalRequestColumns={approvalRequestColumns}
      RequestComponent={Request}
      requestDetailPanels={requestDetailPanels}
    />
  )
})
